import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormValidationService } from '../../../services/form-validation.service';
import { GenericInputComponent } from '../ld-input-generic/ld-input-generic.component';
import { Utils } from '../../../services/utils.service';


export const LD_EMAIL_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => EmailInputComponent),
  multi: true
};


let nextUniqueId = 0;


@Component({
  selector: 'ld-email-input',
  templateUrl: './ld-email-input.template.html',
  providers: [LD_EMAIL_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class EmailInputComponent extends GenericInputComponent {
  id: string = `ld-email-input-${nextUniqueId++}`;

  @Input() label: string;
  @Input() defaultTitle: string;
  @Input() maxlength: number = null;
  @Input() pattern: string = null;
  @Input() placeholder: string = null;
  @Input() name: string = null;

  @HostBinding('class') _class = 'd-block';

  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();


  constructor(elementRef: ElementRef, public formValidation: FormValidationService, changeDetectorRef: ChangeDetectorRef, utils: Utils) {
    super(elementRef, formValidation, changeDetectorRef, utils);

    setTimeout(() => {
      changeDetectorRef.markForCheck();
    }, 0);
  }

  _handleBlur(event) {
    this.blur.emit(event);
  }
}
